interface ShortcutProject {
  name: string;
  icon?: string;
  pwaIcon?: string;
}

interface ShortcutStory {
  name: string;
  storyIcon?: string;
  image?: string;
}

export interface HomeScreenShortcut {
  name: string;
  icon?: string;
}

// What a phone's "Add to Home Screen" shortcut shows (INT-873).
export const getHomeScreenShortcut = (
  project: ShortcutProject,
  story?: ShortcutStory
): HomeScreenShortcut => {
  const projectIcon = project.pwaIcon || project.icon;

  if (!story) return { name: project.name, icon: projectIcon };

  return {
    name: story.name,
    icon: story.storyIcon || story.image || projectIcon,
  };
};
